module.exports = __webpack_public_path__ + "static/media/the-lei-aloha-serenaders.c116c9fd.jpg";